import styled from 'styled-components';
import {alignCenter, dFlex, flexRow, flexColumn} from '../../../globalVariables/GlobalFlex';
import {
    ellipsis,
    mobileMedia,
    TURQUISE_BLUE,
    LIGHT_GRAY5,
    LIGHT_GRAY3,
    GRAY92,
    DARK_GRAY1,
    MATTE_LIGHT_BLUE, desktopMedia
} from '../../../globalVariables/GlobalVariables';
import {checkbox} from '../../../component/checkbox/Checkbox.css';

export const ticketRowStyled = styled.div<{$selected: boolean}>`
   ${dFlex};
   ${alignCenter};
   ${flexRow};
  background: ${({$selected}) => $selected ? 'rgba(142, 237, 255, 0.20)' :  'rgba(204, 204, 204, 0.20)'};
  border: 1.5px solid ${({$selected}) => $selected ? TURQUISE_BLUE : LIGHT_GRAY5};
  border-radius: 12px;
  min-height: 44px;
  padding: 0 10px;
  margin-bottom: 10px;
  ${mobileMedia}{
    margin: 16px 0;
    padding: 0 5px;
    gap: 6px;
    -webkit-tap-highlight-color: transparent;
  }
  transition: border 0.2s, background 0.2s;
  gap: 8px;
  cursor: pointer;
  ${checkbox} {
    margin: 0;
  }
`;
export const title = styled.div`
   font-size: 14px;
    font-weight: 400;
    ${ellipsis};
    flex: 1;
    ${mobileMedia}{ 
        font-size: 12px;
}
`;

export const price = styled(title)`
    font-weight: bold;
    text-align: center;
`;

export const description = styled(title)`
    
`;

export const titleContainer = styled.div`
    ${dFlex}
    ${flexColumn}
    flex: 1;
    text-align: center;
    width: calc(100% - 320px);
    ${mobileMedia}{
        max-width: calc(100% - 220px);
        width: max-content;
        text-align: start;
    }    
`;

export const buttonContainer = styled.div`
    ${dFlex};
    gap: 8px;
    flex-shrink: 0;
`;

export const Button = styled.button<{$selected: boolean}>`
    ${dFlex};
    ${alignCenter};
    gap: 4px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500; 
    cursor: pointer;
    transition: all 0.2s;
    height: 22px;
    width: max-content;
    ${mobileMedia}{
      padding: 6px 7px;
    }
`;

export const rejectButton = styled(Button)`
    background: ${({$selected}) => $selected ?  'transparent': LIGHT_GRAY3};
    color: ${DARK_GRAY1};
    border: 1px solid ${LIGHT_GRAY3};
    ${desktopMedia} {
        &:hover {
            background: ${GRAY92};
        }
    }
`;

export const approveButton = styled(Button)`
    background: ${({$selected}) => $selected ? TURQUISE_BLUE : 'transparent'};
    border: 1px solid  ${TURQUISE_BLUE};
    color: white;
    ${desktopMedia} {
        &:hover {
            background: ${MATTE_LIGHT_BLUE};
        }
    }
`;
